<template>
	<section class="section">
		<div class="content" v-for="(month, index) in months" v-bind:key="index">
			<h1 class="title">{{month.monthName}} {{month.year}}</h1>
			<div v-for="recipe in month.recipes"
				v-bind:key="recipe.id">
				<a v-bind:href="'#/recipe/' + recipe.id">{{ recipe.value.name }}</a> ({{ recipe.formattedDate}})
			</div>
		</div>
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				months: []
			}
		},
		created: function() {
			const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

			var vm = this

			db.query( 'recipes/by_date', {
				descending: true,
				limit: 20
			}).then( function( res ) {
				console.log(res)

				var months = new Array()

				var first = new Date(res.rows[0].key)
				months[0] = {
					monthName: monthNames[first.getMonth()],
					year: first.getFullYear(),
					recipes: []
				}
				
				for( var idx in res.rows )
				{
					var date = new Date(res.rows[idx].key)
					res.rows[idx].formattedDate = monthNames[date.getMonth()] + " " + date.getDate()
					var month = months[months.length-1]
					if( month.monthName == monthNames[date.getMonth()] && month.year == date.getFullYear() )
					{
						month.recipes.push(res.rows[idx])
					}
					else
					{
						var newMonth = {
							monthName: monthNames[date.getMonth()],
							year: date.getFullYear(),
							recipes: []
						}
						months.push(newMonth)
					}
				}

				vm.months = months

			}).catch( function( err ) {
				throw err
			})
		}
	}
</script>
